
































import { Vue, Component } from 'vue-property-decorator'
import store from 'src/assets/store'
import Me from 'src/graphql/person/Me.gql'
import api from 'src/assets/api/gql'
import PersonAvatarChange from 'components/account/PersonAvatarChange.vue'
import NameChange from 'components/account/NameChange.vue'
import EmailChange from 'components/account/EmailChange.vue'
// import PrivacySettings from 'components/account/PrivacySettings.vue'
import PasswordLoginChange from 'components/account/PasswordLoginChange.vue'
import PasswordChange from 'components/account/PasswordChange.vue'
import MenuChange from 'components/account/MenuChange.vue'
import LocaleChange from 'components/account/LocaleChange.vue'
import AccountDelete from 'components/account/Delete.vue'

@Component({
  components: {
    PersonAvatarChange,
    NameChange,
    EmailChange,
    // PrivacySettings,
    PasswordLoginChange,
    PasswordChange,
    MenuChange,
    LocaleChange,
    AccountDelete
  }
})
export default class PageAcount extends Vue {
  Me = Me
  person = store.state.person

  async created () {
    const { data: { me } } = await api.query({
      query: Me
    })
    if (me) {
      store.setPerson(me)
    }
  }
}
